module.exports = __webpack_public_path__ + "img/pic6.0d70a411.jpg";